<template>
  <div>
    <!-- <h1>404 - 页面未找到</h1>
    <p>抱歉，您访问的页面不存在。</p> -->
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
/* 添加你喜欢的样式 */
</style>